export const isDev = process.env.NODE_ENV === "development";

const networkEnv =
  process.env.NODE_ENV === "development" ? "devnet" : "testnet";

export const DEFAULT_NETWORK =
  localStorage.getItem("stratos_network_website_blog") ?? networkEnv;

export const WP_HOST_URL = "https://blog.thestratos.org";
// export const WP_HOST_URL = "";

export const ecosystemRepoUrl =
  "https://raw.githubusercontent.com/stratosnet/ecosystem/main";
export const ecosystemProjectsFileName = "projects.json";
export const ecosystemProjectsImgDirectory = "data/img";
export const ecosystemProjectsImgPreviewDirectory = "previewImages";

export const defaultEcosystemProjectUrl = "https://thestratos.org";

export const stratosSocialMediaLinks = {
  thestratos: "https://www.thestratos.org",
  twtitter: "https://twitter.com/Stratos_Network",
  github: "https://github.com/stratosnet",
  linkedin: "https://www.linkedin.com/company/stratos-network",
  reddit: "https://www.reddit.com/r/stratoscommunity/",
  discord: "https://discord.gg/tpQGpC2nMh",
  mailto: "mailto:info@thestratos.org",
  mailtoClaire: "mailto:claire@thestratos.org",
  medium: "https://stratos-network.medium.com",
  telegram: "https://t.me/StratosOfficial",
  // telegramCommunity: "https://t.me/StratosOfficialAnnouncement",
};

export const stratosCommunityLinks = {
  bountyProgram: "https://blog.thestratos.org/category/111/",
  staking:
    "https://docs.thestratos.org/docs-stratos-chain/mainnet-bridge-and-staking/",
  partners:
    "https://drive.google.com/drive/folders/11Ppq2zdP8Yid6pOshd-TKNKKFvBRTJFe",
};

export const stratosResourcesLinks = {
  tokenomics:
    "https://github.com/stratosnet/stratos-token-economy#stratos-token-economy ",
  technicalDocumentations: "https://docs.thestratos.org/",
};

export const stratosSocialInvestorsLinks = {
  fundamentallabs: "https://www.fundamentallabs.com/",
  kenetic: "https://kenetic.capital",
  fenbushicapital: "https://www.fenbushicapital.vc/index_en.html",
  particleXYZ: "https://twitter.com/ParticleXYZ",
  sparkdigitalcapital: "https://www.sparkdigitalcapital.com",
  bixincapital: "http://bixincapital.com",
  dfg: "https://dfg.group",
  snzholding: "https://snzholding.com",
  nothingresearch: "https://www.nothing-research.com",
};
